import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import TaskForm from "./TaskForm";

export function QuickTaskDialog({ open, onOpenChange, currentUser, onCreated }) {
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [pid, setPid] = useState("");
  const [formOpen, setFormOpen] = useState(false);

  useEffect(() => {
    if (!open) { return; }
    setPid("");
    Promise.all([api.get("/projects"), api.get("/users").catch(() => ({ data: [] }))])
      .then(([p, u]) => { setProjects(p.data); setUsers(u.data); if (p.data.length === 1) setPid(p.data[0].id); })
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, [open]);

  const project = projects.find(p => p.id === pid);
  return (
    <>
      <Dialog open={open && !formOpen} onOpenChange={onOpenChange}>
        <DialogContent className="bg-white border-neutral-200 max-w-md" data-testid="quick-task-dialog">
          <DialogHeader>
            <DialogTitle>New Task</DialogTitle>
            <DialogDescription className="text-xs">Pick one of your projects, then fill in the task.</DialogDescription>
          </DialogHeader>
          {projects.length === 0 ? (
            <div className="text-sm text-neutral-600 rounded-md border border-amber-300 bg-amber-50 p-3" data-testid="quick-task-no-projects">You aren't on any project team yet. Ask your PM or admin to add you.</div>
          ) : (
            <Select value={pid} onValueChange={setPid}>
              <SelectTrigger data-testid="quick-task-project"><SelectValue placeholder="Choose project" /></SelectTrigger>
              <SelectContent>{projects.map(p => <SelectItem key={p.id} value={p.id}>{p.project_name}</SelectItem>)}</SelectContent>
            </Select>
          )}
          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button disabled={!pid} onClick={() => setFormOpen(true)} className="bg-orange-500 hover:bg-orange-600 text-white" data-testid="quick-task-continue">Continue</Button>
          </div>
        </DialogContent>
      </Dialog>
      <TaskForm open={formOpen} onOpenChange={(o) => { setFormOpen(o); if (!o) onOpenChange(false); }} initial={{ assignees: [currentUser?.id].filter(Boolean) }}
        projectId={pid} project={project} users={users} onSaved={onCreated} />
    </>
  );
}
